export const DEFAULT_KO_FORMAT = 'yyyy.MM.dd'
export const DEFAULT_EN_FORMAT = 'yyyy-MM-dd'

export const DEFAULT_DAY_FORMAT = 'E'

export const DATE_FORMATS = {
  'M월 d일 a': { ko: 'M월 d일 a', en: 'MMM d a' },
  'M월 d일(E) a h:mm': { ko: 'M월 d일(E) a h:mm', en: 'MMM d(EEE) h:mm a' },
  'M월 d일 E요일 a h시 m분': {
    ko: 'M월 d일 E요일 a h시 m분',
    en: 'MMM d EEE h:mm a',
  },
  'HH:mm': { ko: 'HH:mm', en: 'HH:mm' },
  'HH:mm:ss': { ko: 'HH:mm:ss', en: 'HH:mm:ss' },
  'a h:mm': { ko: 'a h:mm', en: 'h:mm a' },
  'a hh:mm': { ko: 'a hh:mm', en: 'hh:mm a' },
  'M/d(E)': { ko: 'M/d(E)', en: 'MMM d(EEE)' },
  'MM/dd(E)': { ko: 'MM/dd(E)', en: 'MMM d(EEE)' },
  'yyyy-MM-dd(E)': { ko: 'yyyy-MM-dd(E)', en: 'yyyy-MM-dd(EEE)' },
  'yyyy.MM.dd(E)': { ko: 'yyyy.MM.dd(E)', en: 'yyyy-MM-dd(EEE)' },
  'yyyy년 M월 d일(E)': { ko: 'yyyy년 M월 d일(E)', en: 'yyyy-MM-dd(EEE)' },
  'yy.MM.dd': { ko: 'yy.MM.dd', en: 'yy-MM-dd' },
  'yyyy-MM-dd': { ko: 'yyyy-MM-dd', en: 'yyyy-MM-dd' },
  'yyyy.MM.dd': { ko: 'yyyy.MM.dd', en: 'yyyy-MM-dd' },
  'MM/dd': { ko: 'MM/dd', en: 'MMM d' },
  'MM.dd': { ko: 'MM.dd', en: 'MMM d' },
  'yyyy년 M월 d일': { ko: 'yyyy년 M월 d일', en: 'yyyy-MM-dd' },
  'yyyy년 M월': { ko: 'yyyy년 M월', en: 'MMM yyyy' },
  'yyyy.MM.dd HH:mm:ss': {
    ko: 'yyyy.MM.dd HH:mm:ss',
    en: 'yyyy-MM-dd HH:mm:ss',
  },
  'yyyy-MM-dd HH:mm:ss': {
    ko: 'yyyy-MM-dd HH:mm:ss',
    en: 'yyyy-MM-dd HH:mm:ss',
  },
  'yyyy-MM-dd HH:mm': { ko: 'yyyy-MM-dd HH:mm', en: 'yyyy-MM-dd HH:mm' },
  'yyyy.MM.dd HH:mm': { ko: 'yyyy.MM.dd HH:mm', en: 'yyyy-MM-dd HH:mm' },
  'yyyy/MM/dd HH:mm': { ko: 'yyyy/MM/dd HH:mm', en: 'yyyy-MM-dd HH:mm' },
  'yyyy년 M월 d일 HH:mm': {
    ko: 'yyyy년 M월 d일 HH:mm',
    en: 'yyyy-MM-dd HH:mm',
  },
  'yyyy년 M월 d일 a HH:mm:ss': {
    ko: 'yyyy년 M월 d일 a HH:mm:ss',
    en: 'yyyy-MM-dd HH:mm:ss a',
  },
  'yyyy년 M월 d일 a h:mm': {
    ko: 'yyyy년 M월 d일 a h:mm',
    en: 'yyyy-MM-dd h:mm a',
  },
  'yyyy년 MM월 dd일 a h:mm': {
    ko: 'yyyy년 MM월 dd일 a h:mm',
    en: 'yyyy-MM-dd h:mm a',
  },
  'yyyy. MM. dd': { ko: 'yyyy. MM. dd', en: 'yyyy-MM-dd' },
  'yyyy년 MM월 dd일': { ko: 'yyyy년 MM월 dd일', en: 'yyyy-MM-dd' },
  'yy.MM.dd HH:mm': { ko: 'yy.MM.dd HH:mm', en: 'yy-MM-dd HH:mm' },
  'yyyy년 MM월': { ko: 'yyyy년 MM월', en: 'MMM yyyy' },
  'MM월 dd일': { ko: 'MM월 dd일', en: 'MMM d' },
} as const

export type DateFormatKey = keyof typeof DATE_FORMATS
